const MobileDetect = require('mobile-detect');
const md = new MobileDetect(window.navigator.userAgent);

export function isMobile() {
  return md.mobile() !== null && md.mobile() !== '';
}



// WEBPACK FOOTER //
// ./src/utils/BrowserUtils.js